import React, { memo, useState, useEffect } from 'react';
import { Flex } from 'antd-mobile';
import { ImgWrap } from 'pubBiz';
import PropTypes from 'prop-types';

const defaultProps = {
  data: [],
  containerStyle: {},
  multipleMargin: '0.12rem',
  onPress: null
};

const propTypes = {
  width: PropTypes.any.isRequired, // 宽度 必传
  data: PropTypes.array, // 数据源
  containerStyle: PropTypes.object, // 容器样式
  multipleMargin: PropTypes.number, // 间隙
  onPress: PropTypes.func // 点击事件
};

const AdPictureCell = memo((props) => {
  const {
    width: cellWidth, // any 宽度
    data, // Array 数据源
    containerStyle, // Object 容器样式
    multipleMargin, // Number 间隙宽度
    onPress // Function 点击事件
  } = props;
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (data.length == 1) {
      setSize({
        width: cellWidth,
        height: '3.8rem'
      });
    } else if (data.length == 2) {
      setSize({
        width: `calc((${cellWidth} - ${multipleMargin}) / 2)`,
        height: '3.8rem'
      });
    }
  }, [data.length]);

  const renderItem = (item, index) => {
    const { imgInfo } = item;
    const { imgUrl, width, height } = imgInfo;

    return (
      <Flex key={`AdPictureCell${index}`} onClick={() => onPress && onPress(item)}>
        <ImgWrap
          src={imgUrl || ''}
          mode={'cover'}
          w={size.width}
          h={`calc(${size.width} * ${height} / ${width})`}
        />
      </Flex>
    );
  };

  return (
    <Flex direction="row" align="center" justify="between" wrap="wrap" style={containerStyle}>
      {data.map((item, index) => renderItem(item, index))}
    </Flex>
  );
});

AdPictureCell.defaultProps = defaultProps;
AdPictureCell.propTypes = propTypes;

export default AdPictureCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/AdPictureCell/index.js